import Image from 'next/image';
import { FC } from 'react';

import { cn, getStoryblokImageUrl } from '@/lib/utils';

export interface BackgroundMediaProps {
  image: any;
  video?: any;
  objectFit?: string;
  className?: string;
  layout?: string;
  priority?: boolean;
  quality?: number;
  sizes?: any;
  props?: any;
}

const BackgroundMedia: FC<BackgroundMediaProps> = ({
  image,
  video,
  className,
  priority = false,
  quality = 75,
  sizes = '100vw',
  props,
}) => {
  if (video?.filename) {
    return (
      <div className={cn('group absolute inset-0 h-full w-full', className)}>
        <video
          src={video?.filename}
          muted={true}
          loop={true}
          autoPlay={true}
          playsInline={true}
          className="absolute inset-0 size-full object-cover"
        />
        <p className="absolute bottom-0 right-0 z-10 !m-0 w-full bg-gradient-to-tl from-black/50 to-transparent p-2 pt-6 font-mono text-xs text-theme-black opacity-0 duration-300 empty:hidden group-hover:opacity-100 lg:text-right">
          {video?.title && `${video?.title}`}
          {video?.copyright && ` © ${video?.copyright}`}
          {video?.source && ` / ${video?.source}`}
        </p>
      </div>
    );
  }

  return (
    <div className={cn('group absolute inset-0 h-full w-full', className)}>
      <Image
        alt={image?.alt}
        src={getStoryblokImageUrl(image?.filename, 1500, 0)}
        fill
        sizes={sizes}
        priority={priority}
        quality={quality}
        className="absolute inset-0 size-full object-cover"
        {...props}
      />
      <p className="absolute bottom-0 right-0 z-10 !m-0 w-full bg-gradient-to-tl from-black/50 to-transparent p-2 pt-6 font-mono text-xs text-theme-black opacity-0 duration-300 empty:hidden group-hover:opacity-100 lg:text-right">
        {image?.title && `${image?.title}`}
        {image?.copyright && ` © ${image?.copyright}`}
        {image?.source && ` / ${image?.source}`}
      </p>
    </div>
  );
};

export default BackgroundMedia;
